module.exports = __webpack_public_path__ + "static/media/sketch.40833b5e8ef06668dfbb8b43a536eb16.svg";